import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Checkbox} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {updateInternalUserList, updateExternalUserList} = Actions;

export const IndeterminateCheckbox = ({index, checked, userType}) => {
  const dispatch = useDispatch();

  const handleChange = () => {
    const status = !checked ? 'S' : 'N';
    if (userType === 'internal') {
      dispatch(updateInternalUserList(index, {status}));
    } else {
      dispatch(updateExternalUserList(index, {status}));
    }
  };

  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
    />
  );
};

export const IndeterminateAllCheckbox = ({'column': {filter}, filteredRows}) => {
  const isDataPresent = filteredRows && filteredRows.length;
  const [allSelection, setAllSelection] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (allSelection) {
      const deselectionFromAll = filteredRows.some(
        (item) => item.original.status === 'N'
      );
      setIsIndeterminate(deselectionFromAll);
    }
  }, [filteredRows]);

  const handleAllSelectionChange = () => {
    const status = !allSelection ? 'S' : 'N';

    if (filter === 'internal') {
      dispatch(updateInternalUserList('ALL', {status}));
    } else {
      dispatch(updateExternalUserList('ALL', {status}));
      setIsIndeterminate(false);
    }
    setAllSelection(!allSelection);
  };

  return (
    <Checkbox
      indeterminate={isIndeterminate}
      checked={allSelection}
      onChange={handleAllSelectionChange}
      disabled={!isDataPresent}
    />
  );
};
